export const ApiRoutes = {
  API_BASE_URL: import.meta.env.VITE_APP_API_BASE_URL,
  GEOSERVER_BASE_URL: import.meta.env.VITE_APP_GEOSERVER_HOST,
  WORK_ORDER: '/workorders',
  WORK_ORDER_BY_ID: '/workorders/:workOrderId',
  CONTACTS: '/contacts',
  CONTACTS_BY_ID: '/contacts/:id',
  CONTACTS_GROUPS: '/contacts/groups',
  CONTACTS_GROUP_BY_ID: '/contacts/groups/:groupId',
  CONTACT_DUPLICATE: '/contacts/:id/duplicate',
  CONTACT_MOVE: '/contacts/:id/move',
  GEOSERVER: '/geoserver',
  GEOSERVER_FEATURE_STATS: '/geoserver/feature-stats',
  GEOSERVER_ASSET_LIST: '/geoserver/asset-list',
  ASSET: '/assets',
  MAP: '/maps',
  MAP_BY_ID: '/maps/:mapId',
  MAP_LAYERS: '/maps/:mapId/layers',
  MAP_LAYER_BY_ID: '/maps/:mapId/layers/:layerId',
  MAP_LAYER_GROUPS: '/maps/:mapId/layer-groups',
  MAP_LAYER_GROUP_BY_ID: '/maps/:mapId/layer-groups/:groupId',
  MAP_LEGEND_ORDER: '/maps/:mapId/legend-order',
  MAP_LAYER_BOUNDS: '/filemanager/get-layer-bounds/:layerName',
  DUPLICATE_LAYER: '/maps/duplicate-layer/:layerName',
  DOWNLOAD_LAYER: '/maps/download-layer',
  DOWNLOAD_FEATURES: '/maps/download-features',
  MAP_FEATURES: '/maps/get-features',
  MAP_FEATURES_MAPPING: '/maps/get-features-mapping',
  // Server-driven attribute table — paginated/filtered/sorted, scales past 50k.
  MAP_FEATURE_TABLE: '/maps/feature-table',
  MAP_FEATURE_TABLE_UPDATE: '/maps/feature-table/:layerName',
  MAP_FEATURE_CQL: '/maps/feature-cql',
  // Async feature export (download at scale): enqueue + poll for signed URL.
  MAP_EXPORT: '/maps/export',
  MAP_EXPORT_STATUS: '/maps/export/:jobId',
  // Symbology data — schema + PostGIS aggregation, scales with layer size.
  SYMBOLOGY_FIELDS: '/maps/symbology/fields',
  SYMBOLOGY_DISTINCT_VALUES: '/maps/symbology/distinct-values',
  SYMBOLOGY_VALUE_SAMPLE: '/maps/symbology/value-sample',
  MAP_QUERY: '/maps/query',
  MAP_PROXIMITY: '/maps/proximity',
  MAP_LAYERS_IN_EXTENT: '/maps/layers-in-extent',
  MAP_FEATURE_BY_ID: '/maps/features/:featureId',
  MAP_LAYER_FEATURES_UPDATE: '/maps/layers/:layerName/update-features',
  // Create Feature Tool (Sprint 4)
  MAP_FEATURE_LAYERS: '/maps/:mapId/feature-layers',
  MAP_CREATE_FEATURE: '/maps/feature-layers/:layerName/features',
  MAP_UPDATE_FEATURE: '/maps/feature-layers/:layerName/features/:gid',
  MAP_FEATURE_ATTACHMENTS: '/maps/feature-layers/:layerName/features/:gid/attachments',
  MAP_FEATURE_AT: '/maps/feature-layers/:layerName/feature-at',
  MAP_SKETCHES: '/maps/:mapId/sketches',
  MAP_SKETCH_BY_MAP: '/maps/:mapId/sketches/:sketchId',
  MAP_SKETCH_BY_ID: '/maps/sketches/:sketchId',
  MAP_SKETCH_ITEMS: '/maps/sketches/:sketchId/items',
  MAP_SKETCH_ITEM: '/maps/sketch-item/:id',
  MAP_SKETCH_SAVE: '/maps/sketches/:sketchId/save-sketch',
  FILEMANAGER: '/filemanager',
  FILE_MANAGER: '/filemanager',
  FILE_UPLOAD: '/filemanager/upload-file',
  FEATURES_UPLOAD: '/filemanager/upload-features',
  FILE_SAVE_LAYER: '/filemanager/save-layer',
  FILE_SAVE_FEATURES: '/filemanager/save-features',
  FILEMANAGER_GET_FILE_MAPPING: '/filemanager/getfilemapping',
  FILEMANAGER_DATASET_FOR_FILES: '/filemanager/dataset-for-files',
  FILEMANAGER_CREATE_FOLDER: '/filemanager/create-folder',
  FILEMANAGER_USERS: '/filemanager/users',
  FILEMANAGER_USER: '/filemanager/user',
  FILEMANAGER_GROUPS: '/filemanager/groups',
  FILEMANAGER_PERMISSIONS: '/filemanager/permissions',
  // Spatial dataset preview (US-109521)
  FILEMANAGER_SPATIAL_PREVIEW: '/filemanager/spatial-preview/:fileId',
  FILEMANAGER_SPATIAL_PREVIEW_SESSION: '/filemanager/spatial-preview/session/:sessionId',
  FILEMANAGER_SPATIAL_PREVIEW_FEATURES: '/filemanager/spatial-preview/:sessionId/features',
  FILEMANAGER_SPATIAL_PREVIEW_CLOSE: '/filemanager/spatial-preview/:sessionId',
  S3: '/s3',
  FILEMANAGER_INITIATE_DOWNLOAD: '/filemanager/downloads',
  FILEMANAGER_POLL_TO_TRIGGER_DOWNLOAD: '/filemanager/downloads/:jobId',
  // Permanent delete from Trash (soft-delete lives on FILEMANAGER_DELETE below).
  FILEMANAGER_PREVIEW_URL: '/filemanager/file/:id/view-link',
  FILEMANAGER_DELETE_ITEMS: '/filemanager/delete-items',
  FILEMANAGER_RESTORE_ITEMS: '/filemanager/restore-items',
  // Soft-delete (move to Trash): read-only summary preview + execute.
  FILEMANAGER_DELETE_SUMMARY: '/filemanager/delete/summary',
  FILEMANAGER_DELETE: '/filemanager/delete',
  FILEMANAGER_MOVE: '/filemanager/move',
  FILEMANAGER_RENAME_ITEM: '/filemanager/:itemId/rename',

  CREATE_WMS: '/maps/:mapId/create-wms',
  WMS_STORE: '/geoserver/rest/workspaces/:workspace/wmsstores',
  PUBLISH_WMS_LAYER: '/geoserver/rest/workspaces/:workspace/wmsstores/:storeName/wmslayers',
  MAP_ICONS: '/icons',
  ICON_URL: '/icons/:key',
  ICON_PRESIGN: '/icons/presign',
  RECENT_ICONS: '/icons/recent',

  PRESIGNED_URL: '/s3/presigned-url',
  S3_UPLOAD_COMPLETE: '/s3/upload-complete',
  SAVE_LAYER: '/s3/save-layer',
  // S3 multipart upload (client-driven, for GB-sized files)
  S3_MULTIPART_CREATE: '/s3/multipart/create',
  S3_MULTIPART_SIGN_PARTS: '/s3/multipart/sign-parts',
  S3_MULTIPART_COMPLETE: '/s3/multipart/complete',
  S3_MULTIPART_ABORT: '/s3/multipart/abort',

  //Auth
  LOGIN: '/auth/login',
  FORGOT_PASSWORD: '/auth/forgot-password',
  RESET_PASSWORD: '/auth/reset-password/:uuid',

  //Home
  DASHBOARD_SERVICES: '/dashboard/services',
  DASHBOARD_SETTINGS: '/dashboard/settings',

  //My Profile
  PROFILE: '/org/admin/profile',
  PROFILE_PASSWORD: '/org/admin/profile/password',
  PROFILE_SUBSCRIPTION_RENEW: '/org/admin/subscriptions/renew',
  PROFILE_SUBSCRIPTION_SUBSCRIBE: '/org/admin/subscriptions/subscribe',

  //User Management
  USERS: '/org/users',
  USER_BY_ID: '/org/users/:id',
  ROLES_AVAILABILITY: '/org/roles/availability',
  GROUPS: '/org/groups',
  GROUP_MANAGER_GROUPS: '/org/groups',
  GROUP_MANAGER_GROUP_BY_ID: '/org/groups/:id',
  GROUP_MANAGER_MEMBERSHIP: '/org/groups/:groupId/users/:userId',
  GROUP_MANAGER_DUPLICATE_USER: '/org/groups/users/:userId/duplicate',
  GROUP_MANAGER_MOVE_USER: '/org/groups/:groupId/users/:userId/move',
  GROUP_MANAGER_META_GROUPS: '/org/groups/meta/groups',
  GROUP_MANAGER_META_USERS: '/org/groups/meta/users',
  GROUP_MANAGER_META_ICONS: '/org/groups/meta/icons',
  GROUP_MANAGER_META_MAPS: '/org/groups/meta/maps',
  GROUP_MANAGER_META_FILES: '/org/groups/meta/files',

  //Client Management
  CLIENTS: '/admin/clients',
  CLIENT_BY_ID: '/admin/clients/:id',
  CLIENT_ARCHIVE: '/admin/clients/:id/archive',
  CLIENT_UNARCHIVE: '/admin/clients/:id/unarchive',
  ADD_ONS: '/admin/addons',
  PAYMENT_GROUPS: '/admin/payment-groups',
  SUBSCRIPTION_TYPES: '/admin/subscriptions/types',

  //Select Client (CES Admin)
  CLIENTS_FOR_SELECTION: '/clients',
  CLIENT_VIEW_AS: '/clients/:clientId/view-as',

  //Asset Manager
  ASSET_MANAGER_STATUS: '/asset-manager/status',
  ASSET_MANAGER_META_LAYERS: '/asset-manager/meta/layers',
  ASSET_MANAGER_LAYER_FIELDS: '/asset-manager/meta/layers/:layerId/fields',
  ASSET_MANAGER_LAYER_KEY_FIELD: '/asset-manager/meta/layers/:layerId/key-field',
  ASSET_MANAGER_LIST_CONFIG: '/asset-manager/asset-list/config',
  ASSET_MANAGER_ASSETS: '/asset-manager/assets',
  ASSET_MANAGER_ASSET_DETAILS: '/asset-manager/assets/:layerId/:keyValue',
  ASSET_MANAGER_WORK_ORDERS: '/asset-manager/work-orders',
  ASSET_MANAGER_WORK_ORDER_SETTINGS: '/asset-manager/work-orders/settings',
  ASSET_MANAGER_WORK_ORDER_BY_ID: '/asset-manager/work-orders/:id',
  ASSET_MANAGER_WORK_ORDER_STATUS: '/asset-manager/work-orders/:id/status',
  ASSET_MANAGER_WORK_ORDER_ATTACHMENT: '/asset-manager/work-orders/:id/attachments/:attachmentId',
  ASSET_MANAGER_LAYER_FIELD_VALUES: '/asset-manager/meta/layers/:layerId/fields/:field/values',
  ASSET_MANAGER_STATISTICS: '/asset-manager/statistics',
  ASSET_MANAGER_STATISTIC_BY_ID: '/asset-manager/statistics/:id',
};
